import { Component, Input } from '@angular/core';

import { MasterDataService } from '../../services/master-data.service';
import { ApiCallCachingService } from '../../services/api-call-caching.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';

import { JurisdictionObligationSimpleListItem } from '../../models/master-data/jurisdiction-obligation-simple-list-item.model';

@Component({
  selector: 'spv2-jurisdiction-obligation-dropdown',
  templateUrl: './dropdown-base/dropdown-base.component.html',
  styleUrls:['./dropdown-base/dropdown-base.component.scss']
})
export class JurisdictionObligationDropdownComponent extends DropdownBaseComponent<string, JurisdictionObligationSimpleListItem> {
  private _legalEntityId : string;
  @Input() public set legalEntityId(v : string) {
    this._legalEntityId = v;
    if(this.value) {
      this.value = null;
      this.valueChange.emit(this.value);
    }
    this.debounceTrigger.execute(null);
    
  }

  get uniqueName() {
    return "jurisdictionObligations" + this._legalEntityId;
  } 

  textField = "name";
  valueField = "id";

  enableCache = false;
  loadDataAutomatically = false;

  dataFunction = (filter : string) => {
    if(this._legalEntityId) return this.masterDataService.getSimpleJurisdictionObligationList(filter, this._legalEntityId);
  }

  constructor(private masterDataService: MasterDataService, cachingService: ApiCallCachingService) {
    super(cachingService);
  }
}
